import type { IconComponent } from "@/types";
import { useId } from "react";

export const Logo: IconComponent = (props) => {
  const id = useId();

  return (
    <svg
      {...props}
      role="presentation"
      version="1.1"
      viewBox="0 0 327 96"
      xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter height="200%" id={`${id}-1`} width="200%" x="-50%" y="-50%">
          <feGaussianBlur stdDeviation="1.5" />
        </filter>
        <filter height="200%" id={`${id}-2`} width="200%" x="-50%" y="-50%">
          <feGaussianBlur stdDeviation="4" />
        </filter>
        <filter height="200%" id={`${id}-3`} width="200%" x="-50%" y="-50%">
          <feGaussianBlur stdDeviation="0.5" />
        </filter>
      </defs>
      <path
        d="M123.16 17.55H146.81C171.34 17.55 183.61 29.64 183.61 47.91V48.09C183.61 66.36 171.08 79.33 146.1 79.33H123.15V17.55H123.16ZM143.81 35.55V61.32H147.25C156.69 61.32 162.78 57.44 162.78 48.52V48.34C162.78 39.43 156.69 35.54 147.25 35.54H143.81V35.55Z"
        fill="#ffffff"
      />
      <path
        d="M188.51 17.55H241.64V34.49H208.81V40.76H235.26V55.68H208.81V62.39H241.64V79.33H188.51V17.55Z"
        fill="#ffffff"
      />
      <path
        d="M247.2 17.55H299.94V35.2H267.85V43.05H294.16V59.11H267.85V79.32H247.2V17.55Z"
        fill="#ffffff"
      />
      <path d="M305.52 17.55H326.17V79.33H305.52V17.55Z" fill="#ffffff" />
      <path
        d="M112.17 95.09V0H78.8L78.76 49.14L58.97 0.01H38.65L0 95.09H35.4L39.03 86.05L58.66 86.06L62.29 95.09H112.17Z"
        fill="#ffffff"
      />
      <path
        d="M110.56 93.48V1.59H80.4L80.36 57.4L57.93 1.59H39.7L2.40997 93.48L34.28 93.55L37.9 84.55L59.73 84.48L63.37 93.48H110.56Z"
        fill="#80b8dc"
      />
      <path
        d="M108.95 88.64V6.81H82L81.99 65.33L58.33 6.81H39.29L6.09003 88.64H34.56L37.97 80.14H59.7L63.17 88.64H108.95Z"
        fill="#1975b6"
      />
      <path
        d="M107.34 83.96V12.12H83.57L83.59 73.26L58.74 12.12H38.88L9.71997 83.96H34.71L37.93 75.96H59.69L62.96 83.96H107.34Z"
        fill="#0a4465"
      />
      <path
        d="M38.41 17.46L13.37 79.2H34.93L38 71.66H59.62L62.7 79.2H84.27L59.19 17.46H38.41Z"
        fill="#0f1830"
      />
      <path d="M105.79 17.46H85.19V79.2H105.79V17.46Z" fill="#0f1830" />
      <circle cx="49" cy="47" fill="#0f1830" r="13" />
      <circle cx="49" cy="47" fill="#ff0000" filter={`url(#${id}-1)`} r="5">
        <animate
          attributeName="r"
          dur="2s"
          repeatCount="indefinite"
          values="5;7.5;5"
        />
      </circle>
      <circle cx="49" cy="47" fill="#ff2600" filter={`url(#${id}-2)`} r="5">
        <animate
          attributeName="r"
          dur="2s"
          repeatCount="indefinite"
          values="5;7.5;5"
        />
      </circle>
      <circle cx="49" cy="47" fill="#ababab" filter={`url(#${id}-3)`} r="5">
        <animate
          attributeName="fill"
          dur="2s"
          repeatCount="indefinite"
          values="#ababab;#ffffff;#ababab"
        />
        <animate
          attributeName="r"
          dur="2s"
          repeatCount="indefinite"
          values="5;6;5"
        />
      </circle>
    </svg>
  );
};

export const LogoStr = `
<svg version="1.1" viewBox="0 0 327 96" xmlns="http://www.w3.org/2000/svg">
	<defs>
		<filter height="200%" id="logo-1" width="200%" x="-50%" y="-50%">
			<feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
		</filter>
		<filter height="200%" id="logo-2" width="200%" x="-50%" y="-50%">
			<feGaussianBlur stdDeviation="4"></feGaussianBlur>
		</filter>
		<filter height="200%" id="logo-3" width="200%" x="-50%" y="-50%">
			<feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
		</filter>
	</defs>
	<path d="M123.16 17.55H146.81C171.34 17.55 183.61 29.64 183.61 47.91V48.09C183.61 66.36 171.08 79.33 146.1 79.33H123.15V17.55H123.16ZM143.81 35.55V61.32H147.25C156.69 61.32 162.78 57.44 162.78 48.52V48.34C162.78 39.43 156.69 35.54 147.25 35.54H143.81V35.55Z" fill="black"></path>
	<path d="M188.51 17.55H241.64V34.49H208.81V40.76H235.26V55.68H208.81V62.39H241.64V79.33H188.51V17.55Z" fill="black"></path>
	<path d="M247.2 17.55H299.94V35.2H267.85V43.05H294.16V59.11H267.85V79.32H247.2V17.55Z" fill="black"></path>
	<path d="M305.52 17.55H326.17V79.33H305.52V17.55Z" fill="black"></path>
	<path d="M112.17 95.09V0H78.8L78.76 49.14L58.97 0.01H38.65L0 95.09H35.4L39.03 86.05L58.66 86.06L62.29 95.09H112.17Z" fill="#fcfcfc"></path>
	<path d="M110.56 93.48V1.59H80.4L80.36 57.4L57.93 1.59H39.7L2.40997 93.48L34.28 93.55L37.9 84.55L59.73 84.48L63.37 93.48H110.56Z" fill="#80b8dc"></path>
	<path d="M108.95 88.64V6.81H82L81.99 65.33L58.33 6.81H39.29L6.09003 88.64H34.56L37.97 80.14H59.7L63.17 88.64H108.95Z" fill="#1975b6"></path>
	<path d="M107.34 83.96V12.12H83.57L83.59 73.26L58.74 12.12H38.88L9.71997 83.96H34.71L37.93 75.96H59.69L62.96 83.96H107.34Z" fill="#0a4465"></path>
	<path d="M38.41 17.46L13.37 79.2H34.93L38 71.66H59.62L62.7 79.2H84.27L59.19 17.46H38.41Z" fill="#0f1830"></path>
	<path d="M105.79 17.46H85.19V79.2H105.79V17.46Z" fill="#0f1830"></path>
	<circle cx="49" cy="47" r="13" fill="#0f1830"></circle>
	<circle cx="49" cy="47" fill="#ff0000" filter="url(#logo-1)" r="7.5"></circle>
	<circle cx="49" cy="47" fill="#ff2600" filter="url(#logo-2)" r="7.5"></circle>
	<circle cx="49" cy="47" fill="#ffffff" filter="url(#logo-3)" r="6"></circle>
</svg>
`;
